module.exports = __webpack_public_path__ + "static/media/promo-6.8af89aca.jpg";